'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCaretRight } from '@redteclab/icons'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetBrandsIndexPage } from '../../../../url-handling'

export const StoryblokBrandBreadcrumbs: FC<{
  currentBrand: string
}> = ({ currentBrand }) => {
  const publicGlobalConfig = useGlobalConfigContext()

  return (
    <section className="container flex items-center whitespace-nowrap text-xs text-dark-primary-strong">
      <a
        className="hover:text-dark-hover-brand hover:underline focus:underline"
        href={urlResolverGetBrandsIndexPage(publicGlobalConfig)}
      >
        <FormattedMessage id="general.label.brands" />
      </a>
      <IconCaretRight className="size-4 shrink-0" />
      <span>{currentBrand}</span>
    </section>
  )
}
